import { html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { rigSharedStyles } from './heimdall-rig-styles.js';

@customElement('heimdall-rig-office')
export class HeimdallRigOffice extends LitElement {
  @state()
  _libLinked = false;

  @state()
  _libInitialized = false;

  @state()
  _result = '︎';

  onLinkOfficeLib() {
    const script = globalThis.document.createElement('script');
    script.onload = () => {
      this._libLinked = true;
    };
    script.src = 'https://appsforoffice.microsoft.com/lib/1/hosted/office.js';
    script.type = 'text/javascript';
    document.head.appendChild(script);
  }

  onInitializeOfficeLib() {
    if (!('Office' in globalThis)) {
      this._result = 'Office global not found';
      return;
    }
    globalThis.Office.onReady((info) => {
      this._libInitialized = true;
      this._result = JSON.stringify(info, null, 2);
    });
  }

  render() {
    return html`
      <div class="app">
        <h1>📎</h1>
        <p>
          ${this._libLinked ? 'Office lib linked' : 'Office lib not linked'}
        </p>
        <p>
          ${this._libInitialized
            ? 'Office lib initialized'
            : 'Office lib not initialized'}
        </p>
        <pre>${this._result}</pre>
        <button @click=${this.onLinkOfficeLib}>Link Office Lib</button>
        <button @click=${this.onInitializeOfficeLib}>
          Initialize Office Lib
        </button>
      </div>
    `;
  }

  static styles = rigSharedStyles;
}

declare global {
  interface HTMLElementTagNameMap {
    'heimdall-rig-office': HeimdallRigOffice;
  }
}
